import React from "react";
import { HashRouter as Router, Route, Routes, Link } from "react-router-dom";
import Home from "./components/Home";
import Input from "./components/Input";
import Initial from "./components/Initial";
import DecryptionView from "./components/DecryptionView";
import Page2 from "./components/Page2";
import Page3 from "./components/Page3";
import Page4 from "./components/Page4";
import Page5 from "./components/Page5";
import Page6 from "./components/Page6";
import Page7 from "./components/Page7";
import Kset from "./components/Kset";
import Sset from "./components/Sset";
import Final from "./components/Final";
import Complete from "./components/Complete";

function App() {
  return (
    <Router>
      <div>
        <nav>
          <ul>
            <li>
              <Link to="/"></Link>
            </li>
          </ul>
        </nav>

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/input" element={<Input />} />
          <Route path="/initial" element={<Initial />} />
          <Route path="/decryptionview" element={<DecryptionView />} />
          <Route path="/page2" element={<Page2 />} />
          <Route path="/page3" element={<Page3 />} />
          <Route path="/page4" element={<Page4 />} />
          <Route path="/page5" element={<Page5 />} />
          <Route path="/page6" element={<Page6 />} />
          <Route path="/page7" element={<Page7 />} />
          <Route path="/Sset" element={<Sset />} />
          <Route path="/Kset" element={<Kset />} />
          <Route path="/final" element={<Final />} />
          <Route path="/complete" element={<Complete />} />

        </Routes>
      </div>
    </Router>
  );
}

export default App;
